import { useCallback } from 'react';
import { MERGE_PATCH_HEADERS, useApiCall } from './apiHelpers';
import type { CreateOfferInputPayload } from './useCreateOfferInput';

export type UpdateOfferInputPayload = {
  [K in Exclude<keyof CreateOfferInputPayload, 'communicationInput'>]?: CreateOfferInputPayload[K] | null;
};

const useUpdateOfferInput = () => {
  const { authFetch, isReady, run } = useApiCall();

  const updateOfferInput = useCallback(
    async (id: number, payload: UpdateOfferInputPayload): Promise<boolean> => {
      if (!isReady) return false;
      const outcome = await run(
        () => authFetch(`/offer_inputs/${id}`, { method: 'PATCH', headers: MERGE_PATCH_HEADERS, body: JSON.stringify(payload) }),
        "Erreur lors de la mise à jour de l'offre",
      );
      return outcome.ok;
    },
    [authFetch, isReady, run],
  );

  return { updateOfferInput };
};

export default useUpdateOfferInput;
